import { combineReducers, Reducer } from "redux";
import { KnownActions } from "../actions/root.actions";
import {
  IRootStateType,
  IStateType,
} from "../models/root.interface";
import notificationReducer from "./notification.reducer";
import eventReducer from "./events.reducer";
import attendeesReducer from "./attendees.reducer";
import downloadsReducer from "./downloads.reducer";
import subscriptionsReducer from "./subscriptions.reducer";
import marketingReducer from "./marketing.reducer";
import reportsReducer from "./reports.reducer";

const initialState: IRootStateType = {
};

function rootReducer(
  state: IRootStateType = initialState,
  action: KnownActions
): IRootStateType {
  switch (action.type) {
    case "SET_SETTINGS":
      return {
        ...state,
        settings: action.data,
      };
    case "SET_SETTINGS_LOADING":
      return {
        ...state,
        settings: "loading",
      };
    case "SET_SETTINGS_ERROR":
      return {
        ...state,
        settings: "error",
      };
    default:
      return state;
  }
}

const rootReducers: Reducer<IStateType> = combineReducers({
  root: rootReducer,
  notifications: notificationReducer,
  event: eventReducer,
  downloads: downloadsReducer,
  attendees: attendeesReducer,
  subscriptions: subscriptionsReducer,
  marketing: marketingReducer,
  reports: reportsReducer,
});

export default rootReducers;
